export default {
  init() {
    // JavaScript to be fired on the home page
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS

    if ($('.featured-products-carousel').length) {
      $('.featured-products-carousel').slick({
        slidesToShow: 5,
        slidesToScroll: 1,
        appendArrows: '.featured-products-carousel',
        arrows: true,
        dots: false,
        responsive: [
          {
            breakpoint: 1439,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 3,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 1023,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/home.js